import './index.css';
import BasePreloader from './BasePreloader';
import brendingPreloaders from './branding/brendingPreloaders';

const preloader = brendingPreloaders[(new URLSearchParams(window.location.search)).get('pid')] || BasePreloader;

export default new preloader();
